var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.getModuleConfig("".concat(this.isSpecificPage ? 'staff_specific_page' : 'branch_page', ".form_title")) ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("".concat(this.isSpecificPage ? 'staff_specific_page' : 'branch_page', ".form_title"))) + " ")]) : _vm._e(), _vm.getModuleConfig("".concat(this.isSpecificPage ? 'staff_specific_page' : 'branch_page', ".form_desc")) ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("".concat(this.isSpecificPage ? 'staff_specific_page' : 'branch_page', ".form_desc"))) + " ")]) : _vm._e(), !_vm.isSpecificPage && _vm.branchProvider ? _c('ShopSelection', {
    ref: "shopSelection",
    attrs: {
      "branch-provider": _vm.branchProvider,
      "show-branch-code": false,
      "placeholder": _vm.displayPlaceholder
    },
    on: {
      "setBranchModel": _vm.setSelectedBranch,
      "loading": _vm.handleBranchesAreLoading,
      "loaded": _vm.handleBranchesAreLoaded
    },
    model: {
      value: _vm.branchId,
      callback: function callback($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "py-3"
  }, [_vm.branchTitleSection && _vm.branchTitleSection.fields && _vm.selectedBranch ? _c('div', _vm._l(_vm.branchTitleSection.fields, function (group, idx) {
    return _c('div', {
      key: idx,
      staticClass: "section branch_title_section"
    }, [_c('div', {
      staticClass: "section__wrapper"
    }, _vm._l(group, function (field, index2) {
      return _c('div', {
        key: 'field' + index2,
        staticClass: "section__item full"
      }, [_c('div', {
        staticClass: "section__value"
      }, [_vm._v(" " + _vm._s(_vm.getFieldDisplayValue(field)) + " ")])]);
    }), 0)]);
  }), 0) : _vm._e(), _vm.branchSubtitleSection && _vm.branchSubtitleSection.fields && _vm.selectedBranch ? _c('div', _vm._l(_vm.branchSubtitleSection.fields, function (group, idx) {
    return _c('div', {
      key: idx,
      staticClass: "section branch_subtitle_section"
    }, [_c('div', {
      staticClass: "section__wrapper"
    }, _vm._l(group, function (field, index2) {
      return _c('div', {
        key: 'field' + index2,
        staticClass: "section__item full"
      }, [_c('div', {
        staticClass: "section__value"
      }, [_vm._v(" " + _vm._s(_vm.getFieldDisplayValue(field)) + " ")])]);
    }), 0)]);
  }), 0) : _vm._e(), _vm.branchDetailSection && _vm.branchDetailSection.fields && _vm.selectedBranch ? _c('div', _vm._l(_vm.branchDetailSection.fields, function (group, idx) {
    return _c('div', {
      key: idx,
      staticClass: "section mt-3"
    }, [_c('div', {
      staticClass: "section__wrapper"
    }, _vm._l(group, function (field, index2) {
      return _c('div', {
        key: 'field' + index2,
        staticClass: "section__item"
      }, [_c('div', {
        staticClass: "section__title"
      }, [_vm._v(_vm._s(field.title))]), _c('div', {
        staticClass: "section__value"
      }, [_vm._v(" " + _vm._s(_vm.getFieldDisplayValue(field)) + " ")])]);
    }), 0)]);
  }), 0) : _vm._e()]), _vm.branchDetailSection && _vm.branchDetailSection.fields && _vm.selectedBranch && _vm.showCustomerBranchButton ? _c('div', {
    staticClass: "page__button mb-2"
  }, [_c('MemberButton', {
    attrs: {
      "icon-class": this.isBooking ? "mdi-message-text-outline" : "mdi-message-text",
      "button-text": this.isBooking ? _vm.customerBranches.button_add_done_text : _vm.customerBranches.button_add_text,
      "disable-default-click": true
    },
    on: {
      "custom-click": _vm.handleBooking
    }
  })], 1) : _vm._e(), _vm.branchDetailSection && _vm.branchDetailSection.fields && _vm.selectedBranch && _vm.enableFavorite ? _c('div', {
    staticClass: "page__button mb-2"
  }, [_c('MemberButton', {
    attrs: {
      "icon-class": this.isFavorite ? "mdi-star" : "mdi-star-outline",
      "button-text": this.isFavorite ? _vm.favoriteBranches.button_add_done_text : _vm.favoriteBranches.button_add_text,
      "disable-default-click": true
    },
    on: {
      "custom-click": _vm.handleFavorite
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "page__button"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig("".concat(this.isSpecificPage ? 'staff_specific_page' : 'branch_page', ".button_text")),
      "button-url": _vm.getModuleConfig("".concat(this.isSpecificPage ? 'staff_specific_page' : 'branch_page', ".button_url")),
      "type": _vm.getModuleConfig("".concat(this.isSpecificPage ? 'staff_specific_page' : 'branch_page', ".button_action"))
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }